import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import DraggableSkills from '@/common/components/DraggableSkills.vue';
    import {ref, watchEffect, PropType} from 'vue';
    import {FreelancerSkillsService} from '@/common/api/FreelancerSkillsService';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {Skill} from '@/common/types/Skill';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {useSkills} from '@/common/composable/useSkills';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    interface AutocompleteEvent {
        originalEvent: Event;
        value: string;
    }

    interface AutoCompleteCompleteEvent {
        originalEvent: Event;
        query: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SkillsField',
  props: {
        initialSkills: Array,
        category: String,
        jobTitle: String,
        freelancerSkillsService: {type: Object as PropType<FreelancerSkillsService>, required: true},
    },
  emits: ["suggestedSkillsFetched", "update"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const {$msg} = useGlobalProperties();
    const {skills, valueChanged, updateSkills, maxSkills, getSuggestedSkills, isThereTooMuchSkills} = useSkills(
        (props.initialSkills as Skill[]) || [],
        props.freelancerSkillsService,
    );

    const suggestions = ref<string[]>([]);
    const query = ref<string>('');

    const emit = __emit;

    function handleItemSelect(event: AutocompleteEvent) {
        valueChanged(event.value);
        query.value = '';
    }

    async function handleComplete(event: AutoCompleteCompleteEvent) {
        if (event.query) {
            const [data, error] = await props.freelancerSkillsService.search(event.query);
            if (!data || error) {
                pushVJoySnackbar({
                    props: {
                        message: $msg('customer.brief.error.unknown'),
                        level: 'error',
                    },
                });
            } else {
                suggestions.value = data;
            }
        }
    }

    async function fetchSuggestedSkills() {
        if (props.freelancerSkillsService && props.category) {
            const [data, error] = await getSuggestedSkills(props.category, props.jobTitle || null);

            if (data && !error) {
                emit('suggestedSkillsFetched');
            }
        }
    }

    watchEffect(() => fetchSuggestedSkills());

return (_ctx: any,_cache: any) => {
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_VJoyFormError = _resolveComponent("VJoyFormError")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VJoyWrapper, {
      direction: "column",
      align: "stretch"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_VJoyLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.skills.skills.label')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.skills.subtitle')), 1),
          _createVNode(_component_AutoComplete, {
            modelValue: query.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
            suggestions: suggestions.value,
            placeholder: _unref($msg)('customer.brief.exec.form.freelancer.skills.placeholder'),
            "data-testid": "skills-field",
            onOptionSelect: handleItemSelect,
            onComplete: handleComplete
          }, null, 8, ["modelValue", "suggestions", "placeholder"])
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_VJoyLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.skills.label')), 1)
                ]),
                _: 1
              }),
              _createVNode(DraggableSkills, {
                skills: _unref(skills),
                "max-count": _unref(maxSkills),
                "placeholder-count": 2,
                "show-remove-button": true,
                onChange: _unref(updateSkills)
              }, null, 8, ["skills", "max-count", "onChange"])
            ], 512), [
              [_vShow, _unref(skills).length]
            ])
          ]),
          _: 1
        }),
        (_unref(isThereTooMuchSkills))
          ? (_openBlock(), _createBlock(_component_VJoyFormError, {
              key: 0,
              "no-html-error-text": _unref($msg)('customer.brief.exec.form.freelancer.skills.error.max', _unref(maxSkills))
            }, null, 8, ["no-html-error-text"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})